import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

const converter = {
  toFirestore(): firebase.firestore.DocumentData {
    const e = new Error();
    e.name = 'getDriverRewardsOutputRef: unexpected write operation';
    throw e;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<BonusTypes.Rewards.DriverRewardsOutput>,
    options: firebase.firestore.SnapshotOptions,
  ): BonusTypes.Rewards.DriverRewardsOutput {
    const data = {
      ...snapshot.data(options),
    };

    return data;
  },
};

const getDriverRewardsOutputRef = ({
  accountId,
  driver,
  bonusProgramId,
  intervalId,
}: {
  accountId: string;
  driver: string;
  bonusProgramId: string;
  intervalId: string;
}) => {
  return firebase
    .firestore()
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_REWARDS_COLLECTION)
    .where('driver', '==', driver)
    .where('bonusPeriodId', '==', intervalId)
    .where('bonusConfigDocId', '==', bonusProgramId)
    .withConverter(converter);
};

export default getDriverRewardsOutputRef;
